import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { useApiClient } from '../api/react'
import { IGroupDetail, IGroupPrintersResponse } from '../api/types/groups'
import { IConnectState } from '../api/types/state'

export type FullGroupDetail = {
  group: IGroupDetail
  groupPrinters: IGroupPrintersResponse
}

export function getFullGroupDetailKey(groupId: number, includedStates: IConnectState[] = []) {
  return `/full-group-detail/${groupId}/${JSON.stringify(includedStates)}`
}

export function useFullGroupDetail(
  groupId: number,
  includedStates: IConnectState[],
  options: Omit<UseQueryOptions<FullGroupDetail>, 'queryKey'> = {}
) {
  const api = useApiClient()

  return useQuery(
    [getFullGroupDetailKey(groupId, includedStates)],
    async () => {
      const group = await api.app.printerGroups.getGroup(groupId)
      const groupPrinters = await api.app.printerGroups.getGroupPrinters(groupId, {
        limit: group.printer_count,
        state_include: includedStates
      })

      return { group, groupPrinters }
    },
    options
  )
}
